import { render, staticRenderFns } from "./CheckList.vue?vue&type=template&id=2c28e0b8&scoped=true&"
import script from "./CheckList.vue?vue&type=script&lang=js&"
export * from "./CheckList.vue?vue&type=script&lang=js&"
import style0 from "./CheckList.vue?vue&type=style&index=0&id=2c28e0b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c28e0b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c28e0b8')) {
      api.createRecord('2c28e0b8', component.options)
    } else {
      api.reload('2c28e0b8', component.options)
    }
    module.hot.accept("./CheckList.vue?vue&type=template&id=2c28e0b8&scoped=true&", function () {
      api.rerender('2c28e0b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/admin/components/CheckList.vue"
export default component.exports